export const HERO_VIDEOS = [
  "https://cdn.todowith.ai/generated/2ae2c1db-53d0-4920-9cf4-a6b5a96db17b/1773158540515_video.mp4",
  "https://cdn.todowith.ai/generated/2ae2c1db-53d0-4920-9cf4-a6b5a96db17b/1773158556335_video.mp4",
] as const;

/** How long each video plays before crossfading (1 full play of each 5s video) */
export const HERO_VIDEO_CROSSFADE_INTERVAL_MS = 5_000;

/** Duration of the opacity crossfade transition */
export const HERO_VIDEO_CROSSFADE_DURATION_MS = 2000;
